import { render, staticRenderFns } from "./DetGuiasForm.vue?vue&type=template&id=49fec6ff"
import script from "./DetGuiasForm.vue?vue&type=script&lang=js"
export * from "./DetGuiasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports